import * as Yup from 'yup';
export default function getYupValidationSchema(values) {
  return Yup.object().shape({
    firstName: Yup.string()
      .trim()
      .required('First name is required!'),
    lastName: Yup.string()
      .trim()
      .required('Last name is required!'),
    email: Yup.string()
      .trim()
      .email()
      .required('Email is required!'),
    companyCode: Yup.string()
      .trim()
      .required('CompanyCode is required!'),
    userId: Yup.string()
      .trim()
      .required('UserId is required!'),
    password: Yup.string()
      .trim()
      .required('Password is required!')
  });
}
